import React, { FC } from 'react';

const Pill: FC = ({ children }): JSX.Element => (
  <div className="flex items-center justify-between flex-grow-0 h-6 px-1 py-1 mr-2 border rounded bg-gray-15 border-gray-40 hover:border-gray-default hover:shadow min-w-10">
    {children}
  </div>
);

export default Pill;
